module.exports = __webpack_public_path__ + "static/media/specs.48a7fd30.svg";